export enum LugasErrorCodes {
	LugasDown = 400245,
	LugasPlayerInWaitingPeriod = 400253,
	LugasOasisDown = 400268,
	LugasAreaUnchanged = 400274,
	LugasAreaGamblingPreventionInfoRequired = 400275,
	LugasGracePeriod = 400287,
	LugasPossibleAccountMatch = 400247,
	LugasLimitTakeoverNoExistingLimit = 400249,
}
